/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SecureInputs */

const en_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const ar_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#آمن`)
};

const bn_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const de_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const es_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const fr_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const pt_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const zh_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const tr_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const ru_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

const pl_svtag_secure = /** @type {(inputs: Svtag_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SECURE`)
};

/**
* | output |
* | --- |
* | "#SECURE" |
*
* @param {Svtag_SecureInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_secure = /** @type {((inputs?: Svtag_SecureInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SecureInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_secure(inputs)
	if (locale === "bn") return bn_svtag_secure(inputs)
	if (locale === "de") return de_svtag_secure(inputs)
	if (locale === "es") return es_svtag_secure(inputs)
	if (locale === "fr") return fr_svtag_secure(inputs)
	if (locale === "pt") return pt_svtag_secure(inputs)
	if (locale === "zh") return zh_svtag_secure(inputs)
	if (locale === "tr") return tr_svtag_secure(inputs)
	if (locale === "ru") return ru_svtag_secure(inputs)
	if (locale === "pl") return pl_svtag_secure(inputs)
	return en_svtag_secure(inputs)
});